import steps from "state/steps";

const isStepBefore = (firstStep, secondStep) =>
  steps.indexOf(firstStep) < steps.indexOf(secondStep);

export default isStepBefore;



// WEBPACK FOOTER //
// ./src/state/isStepBefore.js